import styled from 'styled-components'

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 600px;
  max-height: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: auto;
    height: 90vh;
  }
`

export const SplitContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const DocumentBrowserPanel = styled.div`
  width: 40%;
  border-right: 1px solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background.primary};

  @media (max-width: 768px) {
    width: 100%;
    height: 50%;
    border-right: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  }
`

export const PDFViewerPanel = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background.secondary};

  @media (max-width: 768px) {
    width: 100%;
    height: 50%;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.default};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.primary};
`

export const ModalHeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ModalHeaderContext = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const ModalHeaderChevron = styled.span`
  color: ${({ theme }) => theme.colors.border.default};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  flex-shrink: 0;
  &::after {
    content: '›';
  }
`

export const ModalHeaderDivider = styled.div`
  width: 140px;
  height: 1px;
  background: ${({ theme }) => theme.colors.border.light};
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const ModalTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`
